const e="free",o="limited",t="locked";export{e as MOTION_FREE,o as MOTION_LIMITED,t as MOTION_LOCKED};
